// extracted by mini-css-extract-plugin
module.exports = {"name":"CustomStatusList_name__1kk6Q","colorStatus":"CustomStatusList_colorStatus__3C2iZ"};